/**
 * ErrorIcon/index.js
 * desc: error icon used for notification ui
 * note: status icon via IconButton; defaults its tooltip + accessible name to the
 *       status label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ErrorIcon = ({ tooltip, ...props }) => (
    <IconButton baseClassName="error icon" label={ tooltip || translate('icons.error.tooltip.text') } tooltip={ tooltip } { ...props }>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm3.833-16.8l.967.967L12.967 12l3.833 3.833-.967.967L12 12.967 8.167 16.8l-.967-.967L11.033 12 7.2 8.167l.967-.967L12 11.033 15.833 7.2z"/></svg>
    </IconButton>
);


export default ErrorIcon;
